import { render, staticRenderFns } from "./SetAmazonWSCredentialsDialog.vue?vue&type=template&id=b1d795a8&"
import script from "./SetAmazonWSCredentialsDialog.vue?vue&type=script&lang=js&"
export * from "./SetAmazonWSCredentialsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports